import { render, staticRenderFns } from "./BlobFeature.vue?vue&type=template&id=883edd72&scoped=true&"
import script from "./BlobFeature.vue?vue&type=script&lang=js&"
export * from "./BlobFeature.vue?vue&type=script&lang=js&"
import style0 from "./BlobFeature.vue?vue&type=style&index=0&id=883edd72&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883edd72",
  null
  
)

export default component.exports